import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CodaltComponent } from '../../codalt.component';
import { Customer } from '../../customer';
import { CustomerProjectType } from '../../customer-project-type.enum';
import { CustomerProject } from '../../customer-project.interface';
import { ConfirmDialogService } from '../../services/confirm-dialog-service/confirm-dialog.service';
import { CustomerProjectService } from '../../services/customer-project/customer-project.service';
import { Settings } from '../../settings.class';
import { User } from '../../user.interface';
import { Utils } from '../../utils.class';

@Component({
    selector: 'app-customer-project-form',
    templateUrl: './customer-project-form.component.html',
    standalone: false,
})
export class CustomerProjectFormComponent extends CodaltComponent implements OnInit {
    @Input({ required: true }) customer: Customer;
    @Input() project?: CustomerProject;
    @Input() types = Settings.projectTypes;
    @Output() saved = new EventEmitter<CustomerProject>();
    projectTemplates: CustomerProject[];
    managers: User[];
    customers: User[];
    saving = false;

    form = new FormGroup({
        name: new FormControl<string | null>(null, Validators.required),
        budget: new FormControl<number | null>(null),
        type: new FormControl<CustomerProjectType | null>(null, Validators.required),
        custom_numbers: new FormControl<boolean | null>(null),
        consumers: new FormControl<boolean | null>(null),
        consumers_site: new FormControl<boolean | null>(null),
        manager: new FormControl<number | null>(null, Validators.required),
        customer_manager: new FormControl<number | null>(null),
        appendAllCurrentParts: new FormControl(false),
        template: new FormControl<number | null>(null),
        archive: new FormControl(false),
        email: new FormControl(false),
    });

    readonly fc = this.form.controls;

    constructor(
        private customerProjectService: CustomerProjectService,
        private confirmDialog: ConfirmDialogService
    ) {
        super();
    }

    ngOnInit(): void {
        if (this.project?.id) {
            this.form.patchValue(this.project);
        } else {
            this.form.patchValue({ type: this.types.length === 1 ? this.types[0].key : null });
        }
        this.subscriptions.add(
            this.customerProjectService.getProjectEditUsers(this.customer.id).subscribe(({ managers, customers }) => {
                this.managers = managers;
                this.customers = customers;
                const userId = this.LocalStorage.getUser().id;
                if (!this.project?.id && !this.fc.manager.value && managers.some(m => m.id === userId)) {
                    this.fc.manager.setValue(userId);
                }
            })
        );
    }

    loadTemplates(type: CustomerProjectType) {
        this.customerProjectService.getProjectTemplates(type).subscribe(({ data }) => (this.projectTemplates = data));
    }

    applyTemplate(id: number) {
        const template = this.projectTemplates.find(p => p.id === id);
        if (template) {
            this.form.patchValue({
                name: template.name,
                manager: template.manager,
                custom_numbers: template.custom_numbers,
            });
        }
    }

    save() {
        Utils.triggerValidationP(this.form)
            .then(() => {
                if (this.form.valid && !this.saving) {
                    if (this.fc.type.value === CustomerProjectType.drillings) {
                        this.fc.custom_numbers.setValue(true);
                    }
                    this.saving = true;
                    this.subscriptions.add(
                        this.customerProjectService
                            // current_customer_id overrides the interceptor's LocalStorage customer.
                            .saveProject({ ...this.project, ...this.form.value, current_customer_id: this.customer.id })
                            .subscribe({
                                next: ({ data }) => {
                                    this.saving = false;
                                    this.saved.emit(data);
                                },
                                error: error => {
                                    this.saving = false;
                                    this.confirmDialog.confirm('Opslaan mislukt', Utils.errorText(error), 'Oke');
                                },
                            })
                    );
                }
            })
            .catch(() => {});
    }
}
